import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import Translate from "helpers/Translate";

function Table({ data }) {
  return (
    <>
      <table className="reports mt-30">
        <thead>
          <tr>
            <th>{Translate({ id: "username" })} </th>
            <th>{Translate({ id: "total_submissions" })} </th>
            <th>{Translate({ id: "total_approved" })} </th>
            <th>{Translate({ id: "total_rejected" })} </th>
            <th>{Translate({ id: "user_accuracy" })} </th>
          </tr>
        </thead>

        {isEmpty(data) && (
          <tbody>
            <tr>
              <td colSpan="10" className="text-center">
                <div className="my-30">
                  {Translate({ id: "no_records_found" })}{" "}
                </div>
              </td>
            </tr>
          </tbody>
        )}

        {!isEmpty(data) && (
          <tbody>
            {data &&
              data.map(stats => {
                const submissions = stats.total_submissions || 0;
                const approvals = stats.total_approvals || 0;
                const rejections = stats.total_rejections || 0;

                let accuracy = Math.round(
                  (approvals / (approvals + rejections)) * 100
                );
                accuracy = isNaN(accuracy) ? 0 : accuracy.toFixed(2);

                return (
                  <tr key={stats.id.id}>
                    <td>
                      <p>{stats.id.fullname}</p>
                      <p>({stats.id.email})</p>
                    </td>
                    <td>{submissions}</td>
                    <td>{approvals}</td>
                    <td>{rejections}</td>
                    <td>{accuracy}%</td>
                  </tr>
                );
              })}
          </tbody>
        )}
      </table>
    </>
  );
}

Table.propTypes = {
  data: PropTypes.array
};

export default Table;
